/* Types */
import { tProduct, combination } from 'src/shared/frontendTypes/product'
import { imageSrc } from 'src/shared/frontendTypes/images'

const getImages = (
  product: tProduct, 
  combination: combination,
  selectedOptions?: number[]
) => {

  const images: imageSrc[] = []

  const { attributes } = product

  // Kombinations Produkt-Bilder
  if (combination.images) for (const image of combination.images)
    images.push({...image, src: 'combinations'})

  // Options Produkt-Bilder
  if (attributes) for (const attribute of attributes) {
    const option = attribute.options.find(o=>(selectedOptions||[]).includes(o.id))
    if (option?.images) for (const image of option.images)
    images.push({...image, src: 'options'})
  }

  // Allgemeine Produkt-Bilder
  if (product.images) for (const image of product.images)
    if (image.type !== 'mood') images.push({...image, src: 'product'})

  return images

}

export default getImages
